import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { ValidacionService } from '../../services/validacion.service'
import { AgmCoreModule } from '@agm/core';
import { Observable } from 'rxjs';
import { write } from 'fs';
import { log } from 'util';
import { TestigosEditComponent } from '../testigos-edit/testigos-edit.component'
import { TestigosComponent } from '../testigos/testigos.component'
import { InmRelTasTestigoComponent } from '../inm-rel-tas-testigo/inm-rel-tas-testigo.component'
import { ValidacionEditComponent } from '../validacion-edit/validacion-edit.component'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ValidacionResult } from './../../models/ValidacionResult';
import { RelacionResult } from '../../models/RelacionesResult';
import { TestigoModel } from '../../models/TestigoModel';
import { TestigoMapa } from '../../models/testigomapa';



@Component({
  selector: 'app-validacion',
  styles: [`
    agm-map {
      height: 600px;
    }
  `],
  templateUrl: './validacion.component.html',
  styleUrls: ['./validacion.component.scss']
})
export class ValidacionComponent implements OnInit {
  idTestigo: number = 1;
  radio: number = 400;

  estado: ValidacionResult;
  contRel: number;

  testigos: TestigoMapa[] = [];
  testigosOtros: TestigoMapa[] = [];

  testigosMod: MatDialogConfig;
  testigosEditMod: MatDialogConfig;
  validacionMod: MatDialogConfig;
  public translate: TranslateService;
  errorMessage: String  = '';
  Mensaje: String = '';
  mapLoaded: boolean = false;

  @Input() tasacionID: number;
  @Input() lat: number;
  @Input() long: number;

  constructor(private _validacionService: ValidacionService, private _router: Router, private _route: ActivatedRoute,
    public _authService: AuthService, private _dialog: MatDialog, _translateService: TranslateService) {

      this.testigosMod = new MatDialogConfig();
      this.testigosMod.disableClose = false;
      this.testigosMod.autoFocus = true;
      this.testigosMod.closeOnNavigation = true;
      this.testigosMod.width = "95%";
      this.testigosMod.disableClose = true;

      this.testigosEditMod = new MatDialogConfig();
      this.testigosEditMod.disableClose = false;
      this.testigosEditMod.autoFocus = true;
      this.testigosEditMod.closeOnNavigation = true;
      this.testigosEditMod.disableClose = true;

      this.validacionMod = new MatDialogConfig();
      this.validacionMod.disableClose = false;
      this.validacionMod.autoFocus = true;
      this.validacionMod.closeOnNavigation = true;
      this.validacionMod.disableClose = true;


  }

  ngOnInit() {
    this.getTestigos();
    this.getEstado();
  }

  public selTestigo() {
    const ref = this._dialog.open(TestigosComponent, this.testigosMod);
    ref.componentInstance.isModal = true;
    ref.afterClosed().subscribe(result => {
      if(result != null){
        this.addTestigo(result);
        this.getEstado();
      }
    });
  }

  public addTestigo(idTestigo:number){
    const ref = this._dialog.open(InmRelTasTestigoComponent, this.testigosEditMod);
    ref.componentInstance.isModal = true;
    ref.componentInstance.testigoId = idTestigo;
    ref.componentInstance.tasacionId = this.tasacionID;
    ref.afterClosed().subscribe(result => {
      this.getTestigos();
      this.getEstado();
    });
  }

  public editRelacion(idRealacion){
    const ref = this._dialog.open(InmRelTasTestigoComponent, this.testigosEditMod);
    ref.componentInstance.isModal = true;
    ref.componentInstance.id = idRealacion;
    ref.afterClosed().subscribe(result => {
      this.getTestigos();
      this.getEstado();
    });
  }

  public validacion(){
    const ref = this._dialog.open(ValidacionEditComponent, this.validacionMod);
    ref.componentInstance.isModal = true;
    ref.componentInstance.tasacionId = this.tasacionID;
    ref.afterClosed().subscribe(result => {
      this.getTestigos();
      this.getEstado();
    });
  }

  public getTestigos() {
    let svc: Observable<any>;
    svc = this._validacionService.getTestigos(this.tasacionID);

    svc.subscribe(data => {
      this.testigos = data;
      console.log(data);
    }, (err) => {
      console.error('Error al recuperar datos de testigos');
    });

    let svc2: Observable<any>;
    svc2 = this._validacionService.getTestigosOtros(this.tasacionID);

    svc2.subscribe(data => {
      this.testigosOtros = data;
      this.mapLoaded = true;
      console.log("Datos aquí");
      console.log(data);
    }, (err) => {
      console.error('Error al recuperar datos de otros testigos');
    });
  }

  public getEstado() {
    this._validacionService.gestEstado(this.tasacionID.toString()).subscribe(resp => {
      this.estado = resp;
    })

    this._validacionService.tieneTestigos(this.tasacionID.toString()).subscribe(resp => {
      this.contRel = resp;
    })
  }

  public eliminarTestigo(idRealacion) {
    var r = confirm("Desea eliminar el testigo?");
    if(r == true){
      this._validacionService.deleteRel(idRealacion).subscribe({
        next: (value) => {
          if(value.correct){
            this.Mensaje = "Borrado correcto";
            this.errorMessage = '';
            this.getTestigos();
          }else{
            this.errorMessage = value.mensaje;
            this.Mensaje = '';
          }
        },
        error: (err) => {
          this.errorMessage = "No se ha podido contactar con la api";
        }
      });
    }
    this.getEstado();
  }
}
